// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2zvj5","info":"UpdateTermsInfo_info__2Qru2"};